import React, {useEffect} from 'react';
import {GameProvider} from './contexts/GameContext';
import Game from './components/Game';
import {createGlobalStyle} from 'styled-components';
import {MuteProvider} from "./contexts/MuteContext";
import {audioEngine} from "./components/audioMap";
import './App.css';

const GlobalStyle = createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    body {
        overflow-x: hidden;
    }
`;

const App: React.FC = () => {
    // const audioContext = new AudioContext();
    useEffect(() => {
        const unlockAudio = () => {
            audioEngine.unlock();
            window.removeEventListener('touchstart', unlockAudio);
            window.removeEventListener('click', unlockAudio);
        };

        window.addEventListener('touchstart', unlockAudio);
        window.addEventListener('click', unlockAudio);

        try {
            audioEngine.loadAll();
        } catch (e) {
            console.error(e);
        }
    }, []);
    return (
        <GameProvider>
            <MuteProvider>
                <GlobalStyle/>
                <Game/>
            </MuteProvider>
        </GameProvider>
    );
};

export default App; 